import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AllBrands } from '../types';
import { getBrands } from './api';

type InitialState = { isError: boolean; data: AllBrands | null };

const initialState: InitialState = { isError: false, data: null };

const fetchBrandsThunk = createAsyncThunk('brands/FETCH_BRANDS', getBrands);

const { actions, reducer } = createSlice({
  name: 'allBrands',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandsThunk.pending, (state) => {
        state.isError = false;
      })
      .addCase(fetchBrandsThunk.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.isError = false;
      })
      .addCase(fetchBrandsThunk.rejected, (state) => {
        state.isError = true;
      });
  },
});

export { actions, reducer, fetchBrandsThunk };
